import React from 'react';
import { Quote } from 'lucide-react';
import { EField, FieldRow } from './EditableField';

export default function SectionAbout({
  section_label = '', title = '', paragraphs = [], author_name = '', author_role = '', author_initial = '', quote_text = '', quote_author = '',
  mode = 'view', onChange,
}) {
  const set = (k) => (v) => onChange?.({ [k]: v });
  const updateP = (i, v) => onChange?.({ paragraphs: paragraphs.map((p, idx) => idx === i ? v : p) });
  const addP = () => onChange?.({ paragraphs: [...paragraphs, 'New paragraph'] });
  const removeP = (i) => onChange?.({ paragraphs: paragraphs.filter((_, idx) => idx !== i) });

  return (
    <section className="py-24 bg-ee-bg2">
      <div className="ee-container grid lg:grid-cols-2 gap-16">
        <div>
          {mode === 'edit' ? (
            <>
              <FieldRow label="Section Label"><EField value={section_label} onChange={set('section_label')} mode={mode} /></FieldRow>
              <FieldRow label="Title"><EField value={title} onChange={set('title')} mode={mode} /></FieldRow>
              <div className="space-y-2">
                {paragraphs.map((p, i) => (
                  <div key={i} className="flex gap-2 items-start">
                    <EField multiline value={p} onChange={(v) => updateP(i, v)} mode={mode} />
                    <button onClick={() => removeP(i)} className="text-xs text-red-400 px-2 py-1">x</button>
                  </div>
                ))}
                <button onClick={addP} className="text-xs px-3 py-1.5 rounded border border-gold/40 text-gold hover:bg-gold/10">+ Paragraph</button>
              </div>
            </>
          ) : (
            <>
              <div className="text-xs tracking-[0.3em] text-gold mb-3 uppercase">{section_label}</div>
              <h2 className="hero-title text-4xl md:text-5xl text-white mb-8">{title}</h2>
              <div className="space-y-5 text-lg text-ee-text2 leading-relaxed">
                {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
              </div>
            </>
          )}
        </div>
        <div className="space-y-6">
          <div className="ee-card p-8 flex items-center gap-4">
            <div className="w-16 h-16 rounded-full gold-grad flex items-center justify-center text-black font-serif text-2xl">
              <EField value={author_initial} onChange={set('author_initial')} mode={mode} />
            </div>
            <div>
              <div className="text-white font-serif text-xl"><EField value={author_name} onChange={set('author_name')} mode={mode} /></div>
              <div className="text-sm text-gold/80"><EField value={author_role} onChange={set('author_role')} mode={mode} /></div>
            </div>
          </div>
          <div className="ee-card p-8 relative">
            <Quote size={28} className="text-gold/40 absolute top-4 left-4" />
            <div className="pl-8 pt-4 font-serif text-2xl text-white italic leading-snug">
              <EField multiline value={quote_text} onChange={set('quote_text')} mode={mode} />
            </div>
            <div className="text-right text-sm text-ee-muted mt-4">— <EField value={quote_author} onChange={set('quote_author')} mode={mode} /></div>
          </div>
        </div>
      </div>
    </section>
  );
}
